// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3O9p1","list":"BalanceDue_list__BQ5CW","listRow":"BalanceDue_listRow__cIW2F","total":"BalanceDue_total__3Q-R4"};